// components
import Header from "./Header";
import InventoryProvider from "./Inventory";

const Page = () => (
  <>
    <Header />
    <InventoryProvider />
  </>
);

export default Page;
